import React from 'react'
import MUIDialog from '@material-ui/core/Dialog'

export const Dialog = props => {
  return <MUIDialog {...props} />
}
